<h2 mat-dialog-title>Edit Variation Metadata</h2>
<mat-dialog-content>
    <form [formGroup]="form" class="dialog-form">
        <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Variation Label</mat-label>
            <input matInput formControlName="variationLabel" placeholder="Enter variation label">
            <mat-error *ngIf="form.get('variationLabel').hasError('required')">
                Variation label is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Variation Description</mat-label>
            <textarea matInput formControlName="variationDescription"
                      placeholder="Enter variation description"
                      rows="3"></textarea>
            <mat-error *ngIf="form.get('variationDescription').hasError('required')">
                Variation description is required
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid">
        Save
    </button>
</mat-dialog-actions>
